
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 24 24","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M7 7.3h9.4c.4 0 .7-.3.7-.6s-.3-.7-.7-.7H7c-.3 0-.6.3-.6.6s.3.7.6.7zM18.4 11.2l-1.1-2.1c-.2-.3-.5-.5-.8-.5H7c-.4 0-.7.2-.8.5l-1 2.1c-.1.3-.1.6 0 .9.2.2.4.4.7.4v4.3c0 .6.5 1 1 1h9.8c.6 0 1.1-.5 1.1-1v-4.3c.3 0 .5-.2.7-.4 0-.2 0-.6-.1-.9zM16 16.6H7.5c-.2 0-.4-.2-.4-.4V13c0-.2.2-.4.4-.4H16c.2 0 .4.2.4.4v3.2c0 .3-.2.4-.4.4z"}}),_c('path',{attrs:{"fill":"none","d":"M0 0h24v24H0z"}})])
          )
        }
      }
    